(function () {
  'use strict';

  function preloadSlotImages(mediaWrap) {
    mediaWrap.querySelectorAll('img').forEach(function (img) {
      img.loading = 'eager';
      if (img.complete) return;
      var src = img.currentSrc || img.src;
      if (src) {
        var loader = new Image();
        loader.src = src;
      }
      if (img.decode) {
        img.decode().catch(function () {});
      }
    });
  }

  function initFindYourBelongings(root) {
    if (!root || root.dataset.fybInit === 'true') return;
    root.dataset.fybInit = 'true';

    var fadeMs = parseInt(getComputedStyle(root).getPropertyValue('--fyb-fade'), 10) || 500;

    var mediaWrap = root.querySelector('[data-fyb-media]');
    var tabsWrap = root.querySelector('[data-fyb-tabs]');
    var descWrap = root.querySelector('[data-fyb-descriptions]');
    var indicator = root.querySelector('[data-fyb-indicator]');
    var arrowLeft = root.querySelector('[data-fyb-arrow-left]');
    var arrowRight = root.querySelector('[data-fyb-arrow-right]');
    var progressBar = root.querySelector('[data-fyb-progress-bar]');

    if (!mediaWrap || !tabsWrap) return;

    preloadSlotImages(mediaWrap);

    var tabs = Array.from(tabsWrap.querySelectorAll('[data-fyb-tab]'));
    var descs = descWrap ? Array.from(descWrap.querySelectorAll('[data-fyb-desc]')) : [];
    var slots = Array.from(mediaWrap.querySelectorAll('[data-fyb-slot]'));
    var videos = Array.from(mediaWrap.querySelectorAll('video'));

    var activeIndex = 0;
    var currentSlot = slots[0] || null;
    var currentVideo = null;
    var raf = null;
    var hasStarted = false;

    videos.forEach(function (video) {
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('muted', '');
      video.muted = true;
      video.playsInline = true;
      video.controls = false;
      video.preload = 'auto';
    });

    function pauseAllVideos() {
      videos.forEach(function (v) {
        v.pause();
      });
    }

    function stopProgressLoop() {
      if (raf) {
        cancelAnimationFrame(raf);
        raf = null;
      }
    }

    function updateProgress() {
      if (!progressBar || !currentVideo) return;
      var duration = currentVideo.duration;
      if (!duration || isNaN(duration) || duration <= 0) {
        progressBar.style.width = '0%';
        return;
      }
      progressBar.style.width = Math.min((currentVideo.currentTime / duration) * 100, 100) + '%';
    }

    function startProgressLoop() {
      stopProgressLoop();
      function loop() {
        updateProgress();
        raf = requestAnimationFrame(loop);
      }
      raf = requestAnimationFrame(loop);
    }

    function moveIndicator(index, instant) {
      if (!indicator || !tabs[index]) return;
      var tab = tabs[index];

      if (instant) indicator.style.transition = 'none';

      indicator.style.width = tab.offsetWidth + 'px';
      indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';

      if (instant) {
        indicator.offsetHeight;
        indicator.style.transition = '';
      }
    }

    function scrollTabIntoView(index) {
      var tab = tabs[index];
      if (!tab) return;

      var wrapLeft = tabsWrap.scrollLeft;
      var wrapWidth = tabsWrap.clientWidth;
      var wrapRight = wrapLeft + wrapWidth;
      var tabLeft = tab.offsetLeft;
      var tabRight = tabLeft + tab.offsetWidth;
      var nextTab = tabs[index + 1];
      var prevTab = tabs[index - 1];

      if (nextTab) {
        var needRight = nextTab.offsetLeft + nextTab.offsetWidth + 4;
        if (needRight > wrapRight) {
          tabsWrap.scrollTo({ left: needRight - wrapWidth, behavior: 'smooth' });
        }
      }

      if (prevTab) {
        var needLeft = prevTab.offsetLeft - 4;
        if (needLeft < wrapLeft) {
          tabsWrap.scrollTo({ left: needLeft, behavior: 'smooth' });
        }
      }

      if (tabLeft < wrapLeft) {
        tabsWrap.scrollTo({ left: tabLeft - 4, behavior: 'smooth' });
      } else if (tabRight > wrapRight) {
        tabsWrap.scrollTo({ left: tabRight - wrapWidth + 4, behavior: 'smooth' });
      }
    }

    function updateArrows() {
      if (!arrowLeft || !arrowRight) return;
      arrowLeft.classList.toggle('is-visible', activeIndex > 0);
      arrowRight.classList.toggle('is-visible', activeIndex < tabs.length - 1);
    }

    function activateTab(index) {
      tabs.forEach(function (tab, i) {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      descs.forEach(function (desc, i) {
        desc.classList.toggle('is-active', i === index);
      });

      scrollTabIntoView(index);
      moveIndicator(index, activeIndex === index);
      activeIndex = index;
      updateArrows();
    }

    function crossfadeToSlot(newSlot) {
      if (!newSlot) return;

      var newVideo = newSlot.querySelector('video');
      var oldSlot = currentSlot;

      stopProgressLoop();

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          slots.forEach(function (slot) {
            slot.classList.remove('is-active', 'is-outgoing');
          });

          if (oldSlot && oldSlot !== newSlot) {
            oldSlot.classList.add('is-outgoing');
          }

          newSlot.classList.add('is-active');
          currentSlot = newSlot;

          if (newVideo) {
            newVideo.muted = true;
            newVideo.currentTime = 0;
            var playPromise = newVideo.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
            currentVideo = newVideo;
            if (progressBar) progressBar.style.width = '0%';
            startProgressLoop();
          } else {
            currentVideo = null;
            if (progressBar) progressBar.style.width = '0%';
          }

          setTimeout(function () {
            if (oldSlot) oldSlot.classList.remove('is-outgoing');
            videos.forEach(function (v) {
              if (v !== currentVideo) v.pause();
            });
          }, fadeMs + 50);
        });
      });
    }

    function seekToTab(index) {
      if (index < 0 || index >= tabs.length) return;
      activateTab(index);
      crossfadeToSlot(slots[index]);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        if (i === activeIndex) return;
        seekToTab(i);
      });
    });

    if (arrowLeft) {
      arrowLeft.addEventListener('click', function () {
        if (activeIndex > 0) seekToTab(activeIndex - 1);
      });
    }

    if (arrowRight) {
      arrowRight.addEventListener('click', function () {
        if (activeIndex < tabs.length - 1) seekToTab(activeIndex + 1);
      });
    }

    root.addEventListener(
      'wheel',
      function (e) {
        if (tabsWrap.scrollWidth <= tabsWrap.clientWidth) return;
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (!tabsWrap.contains(e.target)) return;
        e.preventDefault();
        tabsWrap.scrollLeft += e.deltaY;
      },
      { passive: false }
    );

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        moveIndicator(activeIndex, true);
        updateArrows();
      }, 100);
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            preloadSlotImages(mediaWrap);
            if (!hasStarted) {
              hasStarted = true;
              seekToTab(0);
            } else if (currentVideo) {
              var p = currentVideo.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            }
          } else {
            pauseAllVideos();
            stopProgressLoop();
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(root);
    activateTab(0);
    moveIndicator(0, true);
    updateArrows();
  }

  function boot() {
    document.querySelectorAll('[data-fyb-section]').forEach(initFindYourBelongings);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root =
      document.getElementById('fyb-' + e.detail.sectionId) ||
      document.getElementById('af-' + e.detail.sectionId);
    if (root) {
      root.dataset.fybInit = 'false';
      initFindYourBelongings(root);
    }
  });
})();
